import * as Api from '../../../../global/js/api';
import * as checkout from '../../../../global/js/checkout';
import { EVENT_RELATED_UPDATE, LOCAL_STORE_POSTCODE } from '../../../../global/js/constants';
import { getRelatedVariants } from '../../../../global/js/utils';
import _ from 'lodash';

export class GuaranteedNextdayDelivery {
	constructor() {
		this.$el = $('.guaranteed-nextday-delivery');
		this.$productDetailPage = $('[data-pg="ProductDetailsUpdate"]');
		this.options = {
			productCode: this.$productDetailPage.attr('data-variant-code'),
			ruralPostcodes: window.RURAL_POSTCODES || [],
		};

		this.lowStock = this.$productDetailPage.data('lowStock');
		this.outOfStock = this.$productDetailPage.data('outOfStock');

		this.data = {
			storeList: [],
			store: {},
			variantQuantity: {},
		};
		if (this.$el.length) {
			this.registerEvent();
			this.update();
		}
		this.$samedayDelivery = $('.sameday-delivery');
	}

	update() {
		this.checkStoreVariantDetail().then(() => {
			this.updateDisplay();
		});
	}

	updateSameDayDelivery(forceHide = false) {
		if (forceHide) {
			this.$samedayDelivery.hide();
		} else {
			if (checkout.isSameDay()) {
				this.$samedayDelivery.show();
			} else {
				this.$samedayDelivery.hide();
			}
		}
	}

	registerEvent() {
		$(document).on('change', '.quantityInput:not(.related-input) input', () => {
			this.update();
		});

		$(document).on('click', '.pdp-option', () => {
			this.update();
		});

		this.$el[0].addEventListener('checkStoreVariantDetail', () => {
			this.update();
		});

		$('.relatedProducts').on(EVENT_RELATED_UPDATE, () => {
			this.update();
		});
	}

	async checkStoreVariantDetail() {
		const postcode = window.localStorage.getItem(LOCAL_STORE_POSTCODE);
		const code = this.getProductCodeSelected();
		const quantity = parseInt($('.pdp-desc-qty.quantityInput input').val());
		const seletedVariant = [{ code, quantity }];
		const mainVariants = this.getMainVariants();
		const relatedVariants = getRelatedVariants();
		const allVariants = mainVariants.concat(relatedVariants).concat(code ? seletedVariant : []);
		const endpoint = '/api/findinstore/check-stock-data-by-postcode/';

		this.data.variantQuantity = allVariants.reduce((acc, variant) => {
			acc[variant.code] = parseInt(variant.quantity);

			return acc;
		}, {});

		const variants = Object.keys(this.data.variantQuantity).map((code) => ({ code }));
		return Api.callApi(endpoint, {
			postcode,
			variants,
		}).then((data) => {
			if (data.result === 'SUCCESS') {
				// window[globalKey] = data;
				this.updateData(data);
			}
		});
	}

	updateData(data) {
		this.data.storeList = _.get(data, 'response', [])
		this.data.store = _.get(data, 'response[0]', {});
	}

	checkStoreAvailable() {
		const targetData = {
			GuaranteedNextDayDelivery: false,
			SameDayDelivery: false,
		};

		return this.data.storeList.reduce((acc, store) => {
			const isAvailableQuantity = this.checkAvailableQuantityVariant(store);
			for (const key in acc) {
				const enableDelivery = isAvailableQuantity && this.checkEnableDelivery(store, key);
				const isAvailablePostcodes = enableDelivery && this.checkGuaranteedNextDayDeliveryAvailablePostcodes(store, key);
				const isCutOffTime = isAvailablePostcodes && this.checkGuaranteedNextDayDeliveryCutOffTime(store, key);
				const isAvailale = isCutOffTime && this.checkGuaranteedNextDayDeliveryDaysOfWeek(store, key);

				acc[key] = acc[key] || isAvailale;
			}
			return acc;
		}, targetData);
	}

	getMainVariants() {
		if (productDetailsJson) {
			return productDetailsJson.variants.map(({ code }) => ({ code, quantity: 0 }));
		}

		return [];
	}

	updateDisplay() {
		const {
			GuaranteedNextDayDelivery,
			SameDayDelivery,
		} = this.checkStoreAvailable();

		const {
			ENABLE_SAME_DAY_DELIVERY: enableSameDay,
			ENABLE_GUARANTEED_NEXTDAY_DELIVERY: enableNextDay
		} = window;

		const showSameday = SameDayDelivery && enableSameDay;
		const showNextday = !showSameday && GuaranteedNextDayDelivery && enableNextDay;

		[
			{
				isAvailable: showNextday,
				$el: this.$el,
			},
			{
				isAvailable: showSameday,
				$el: this.$samedayDelivery,
			}
		].forEach(({ isAvailable, $el }) => {
			if (isAvailable) {
				$el.show();
			} else {
				$el.hide();
			}
		});
	}

	checkAvailableQuantityVariant(store) {
		const variantStockValue = _.get(store, 'StockData.VariantStockValue', []);
		const code = this.getProductCodeSelected();
		const hasVariantSelectedFromAPI = variantStockValue.find((variant) => {
			return variant.Code === code;
		});

		if (!hasVariantSelectedFromAPI) {
			return false;
		}

		const isAvailableQuantity = variantStockValue.reduce((acc, variant) => {
			const hasVariantSelected = this.data.variantQuantity[variant.Code];
			let isAvailable = true;
			if (hasVariantSelected) {
				const stockOnHand = variant['StockOnHand'];
				const quantity = this.data.variantQuantity[variant.Code];
				const remainingStock = stockOnHand - quantity;
				const isInStock = remainingStock >= this.outOfStock;
				isAvailable = !variant['IsDropship'] && !variant['IsHeavyItem'] && variant['IsAvailableForDelivery'] && isInStock;
			}
			return acc && isAvailable
		}, true);


		return isAvailableQuantity;
	}

	checkEnableDelivery(store, deliveryName) {
		return _.get(store, `StockData.${deliveryName}.EnableDelivery`, false);
	}

	checkGuaranteedNextDayDeliveryAvailablePostcodes(store, deliveryName) {
		const postcode = window.localStorage.getItem(LOCAL_STORE_POSTCODE);
		const availablePostcodes = (_.get(store, `StockData.${deliveryName}.DeliveryAvailablePostcodes`, []) || []);

		return postcode && availablePostcodes.includes(String(postcode));
	}

	checkGuaranteedNextDayDeliveryCutOffTime(store, deliveryName) {
		const getTime = (time) => new Date('01/01/1970 ' + time).getTime();
		const currentTime = _.get(store, 'StockData.CurrentTimeFormated');
		const guaranteedNextDayDeliveryCutOffTime = _.get(store, `StockData.${deliveryName}.DeliveryCutOffTime`);

		return getTime(currentTime) <= getTime(guaranteedNextDayDeliveryCutOffTime);
	}

	checkGuaranteedNextDayDeliveryDaysOfWeek(store, deliveryName) {
		const date = new Date();
		const day = date.getDay();
		const guaranteedNextDayDeliveryDaysOfWeek = _.get(store, `StockData.${deliveryName}.DeliveryDaysOfWeek`, []);

		return (guaranteedNextDayDeliveryDaysOfWeek || []).includes(String(day));
	}

	getProductCodeSelected() {
		const productType = window.productDetailsJson.type;
		let colorCode = '', sizeCode = '';
		switch (productType) {
			case 'generic':
				return this.$productDetailPage.attr('data-variant-code');

			case 'colorsize':
				sizeCode = $('.pdp-option.active.item-size:visible').attr('data-variant-code');

				return sizeCode;

			case 'color':
				colorCode = $('.pdp-option.active[data-colour-code]:visible').attr('data-variant-code');

				return colorCode;

			case 'size':
				sizeCode = $('.pdp-option.active.item-size:visible').attr('data-variant-code');

				return sizeCode;
		}
	}
}



// WEBPACK FOOTER //
// D:/AzureDevops/vsts-agent-win-x64-2.202.1_06/_work/151/s/FrontEnd/src/views/pages/productDetailsPage/js/guaranteedNextdayDelivery.js